module.exports = __webpack_public_path__ + "img/gxty1.69daaad0.png";